<div>
    Deseja deletar a conexão <strong>{{updateData.connection.connectionId}}</strong>? Esta ação é irreversível 
    <div class="mt-2 d-flex gap-2">
        <button (click)="confirm()" class="btn btn-primary">Confirmar</button>
        <button (click)="cancel()" class="btn btn-danger">Cancelar</button>
    </div>
</div>
